"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var base = {
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  shape: {
    borderRadius: 0
  },
  shadows: Array(25).fill('none'),
  palette: {
    type: 'dark'
  },
  scrollbar: {
    style: 'none' // oneOf['none', 'default', 'primary']
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 958,
      lg: 1280,
      xl: 1920
    }
  },
  navigation: {
    number: 2,
    height: '3.5em',
    tablet: {
      number: 2,
      height: '3.9em'
    },
    desktop: {
      number: 2,
      height: '3.9em'
    }
  },
  scratch: {
    height: 38,
    tablet: {
      height: 38
    },
    desktop: {
      height: 38
    }
  },
  gutters: {
    page: {
      xs: '1rem',
      sm: '1rem',
      md: '2rem',
      lg: '7rem',
      xl: '7rem'
    },
    condensed: {
      xs: '1rem',
      sm: '1rem',
      md: '1rem',
      lg: '1rem',
      xl: '1rem'
    },
    modal: {
      xs: '30px',
      md: '50px'
    }
  }
};
var _default = base;
exports.default = _default;